
import { useLocation, useNavigate } from '@tanstack/react-router';

import Box from '@mui/material/Box';

import { PageNavigationProvider, usePageNavigation } from '@src/context/PageNavigationContext';
import Footer from '@src/layout/Footer';
import Header from '@src/layout/Header';

const StyleSheet = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: 6,
  },
};

function getCurrentPageFromPath(pathname) {
  if (pathname === '/' || pathname === '/home') {
    return [];
  }
  const parts = pathname.split('/').filter(Boolean);
  return parts || [];
}

function Root(props) {
  return <Box {...props} sx={StyleSheet.root} />;
}

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { triggerReset } = usePageNavigation();

  const currentPage = getCurrentPageFromPath(location.pathname);

  const handleNavigate = (to) => {
    // Check if navigating to the same page
    if (to === location.pathname) {
      triggerReset();
    }
    navigate({ to });
  };

  return (
    <Box
      component="nav"
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        width: '100%',
      }}
    >
      <Header currentPage={currentPage} onNavigate={handleNavigate} />
    </Box>
  );
}


export default function DefaultLayout({ children }) {
  return (
    <PageNavigationProvider>
      <LayoutContent>{children}</LayoutContent>
    </PageNavigationProvider>
  );
}

function LayoutContent({ children }) {
  // Define navigate within this component's scope
  const navigate = useNavigate();

  return (
    <Root>
      <Navigation />
      {children}
      <Footer onNavigate={(to) => navigate({ to })} />
    </Root>
  );
}
